var _g, _path, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChatbotMainIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_24745_9633)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ii_24745_9633)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.6974 11.9341C23.6974 5.43666 18.4301 0.169418 11.9327 0.169418C5.43521 0.169418 0.167969 5.43666 0.167969 11.9341C0.167969 18.4316 5.43521 23.6988 11.9327 23.6988C18.4301 23.6988 23.6974 18.4316 23.6974 11.9341Z",
    fill: "url(#paint0_linear_24745_9633)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7827 11.9338C23.7827 5.38988 18.4778 0.085022 11.9339 0.085022C5.39006 0.085022 0.0852051 5.38988 0.0852051 11.9338C0.0852051 18.4776 5.39006 23.7825 11.9339 23.7825C18.4778 23.7825 23.7827 18.4776 23.7827 11.9338Z",
    stroke: "url(#paint1_linear_24745_9633)",
    strokeWidth: 0.192308
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_24745_9633",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.6962 11.9362C23.6962 5.4387 18.4289 0.171463 11.9315 0.171463C5.43399 0.171463 0.166748 5.4387 0.166748 11.9362C0.166748 18.4336 5.43399 23.7009 11.9315 23.7009C18.4289 23.7009 23.6962 18.4336 23.6962 11.9362Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_24745_9633)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_24745_9633)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.196 7.92856C15.3413 7.92856 9.43254 23.9486 -1.83154 13.4355L-0.0793524 27.2027L35.2147 28.2039V11.4329C27.9557 17.1902 25.0507 7.92861 20.196 7.92856Z",
    fill: "url(#paint2_linear_24745_9633)",
    fillOpacity: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_di_24745_9633)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.67744 7.92856C8.53215 7.92856 14.4409 23.9486 25.705 13.4355L23.9528 27.2027L-11.3413 28.2039V11.4329C-4.08225 17.1902 -1.17725 7.92861 3.67744 7.92856Z",
    fill: "url(#paint3_linear_24745_9633)",
    fillOpacity: 0.7
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii_24745_9633",
    x: -0.0109863,
    y: -0.0111389,
    width: 23.8899,
    height: 24.659,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.92308
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.368627 0 0 0 0 0.439216 0 0 0 0 0.929412 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_24745_9633"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.76923
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.30769
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_24745_9633",
    result: "effect2_innerShadow_24745_9633"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_24745_9633",
    x: -4.90846,
    y: 5.23625,
    width: 43.2002,
    height: 26.4292,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.384616
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.53846
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_24745_9633"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_24745_9633",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_di_24745_9633",
    x: -14.4182,
    y: 2.42856,
    width: 45.6233,
    height: 29.2369,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.384616
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.53846
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_24745_9633"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_24745_9633",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 13.8462,
    dy: -6.53848
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.75
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_24745_9633"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_24745_9633",
    x1: 5.21,
    y1: 20.1694,
    x2: 22.3345,
    y2: 8.33023,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5BB7ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.678371,
    stopColor: "#4862F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#8A7DEC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_24745_9633",
    x1: 23.6636,
    y1: 0.169056,
    x2: 0.204306,
    y2: 23.6985,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3AEF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_24745_9633",
    x1: 16.6916,
    y1: 7.92856,
    x2: 16.6916,
    y2: 28.2039,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6C7DE5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_24745_9633",
    x1: 7.18185,
    y1: 7.92856,
    x2: 7.18185,
    y2: 28.2039,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6C7DE5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_24745_9633"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatbotMainIcon);
export default __webpack_public_path__ + "static/media/chatbot_main_icon.6c812aa94f8ddce1dff47a8890beb58b.svg";
export { ForwardRef as ReactComponent };